import { RIGHTSHOLDER_VALIDATION_STATUSES } from '@Const/rightsholder-statuses'

export const getStrRHStatus = (validationStatus: string) => {
    if (validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.DONE.name) {
        return 'Done'
    } else if (
        validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.NOT_VALIDATED.name ||
        validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.TRULIOO_PASSED.name ||
        validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.HFA_APPROVED_EXISTING.name ||
        validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.HFA_COPIED.name ||
        validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.HFA_APPROVED_NEW.name
    ) {
        return 'Pending'
    } else if (
        validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.TROLIOO_FAILED.name ||
        validationStatus === RIGHTSHOLDER_VALIDATION_STATUSES.HFA_REJECTED.name
    ) {
        return 'Failed'
    } else {
        return
    }
}
